export default __webpack_public_path__ + "static/media/medaille-qdo-bronze-realisation.9b8325fb.png";